<i [class]="'alert__icon bx ' + icon()" aria-hidden="true"></i>
<div class="alert__body">
  @if (heading()) {
    <strong class="alert__heading">{{ heading() }}</strong>
  }
  <span class="alert__msg"><ng-content /></span>
  <span class="alert__action"><ng-content select="[alert-action]" /></span>
</div>
@if (dismissible()) {
  <button type="button" class="alert__close" (click)="dismissed.emit()" aria-label="Dismiss">
    <i class="bx bx-x" aria-hidden="true"></i>
  </button>
}
